/**
 * Tracking only — does NOT apply any Shopify discount.
 *
 * 1) Capture ?discount_campaign=CODE from any URL
 * 2) Save to sessionStorage + cookie (+ localStorage backup)
 * 3) URL param on page load → immediately set cart attribute discount_campaign
 * 4) Stored code + cart has items → keep cart attribute
 * 5) No stored code → remove cart attribute
 *
 * Debug:
 *   window.ttDiscountCampaign.status()
 */
(function DiscountCampaignAttr() {
  if (window.__ttDiscountCampaignAttr) return;
  window.__ttDiscountCampaignAttr = true;

  var STORAGE_KEY = 'tt_discount_campaign';
  var COOKIE_KEY = 'tt_discount_campaign';
  var LOCAL_KEY = 'tt_discount_campaign';
  var ATTR_KEY = 'discount_campaign';
  var URL_PARAM_KEY = 'discount_campaign';
  var UNWANTED_ATTR_KEYS = [
    'codk_campaign_attribution',
    'conversion_captured',
    '_eventSourceUrl',
    '_clientUserAgent',
  ];
  var lastSyncedState = '';
  var isSyncing = false;
  var syncTimer = null;
  var isInternalCartRequest = false;

  function sanitizeCode(value) {
    if (!value) return '';
    return String(value).trim().slice(0, 64);
  }

  function readCookie(name) {
    try {
      var match = document.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
      );
      return match ? decodeURIComponent(match[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function writeCookie(name, value) {
    try {
      var secure = location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; SameSite=Lax' + secure;
    } catch (e) {}
  }

  function readFromUrl() {
    try {
      var code = sanitizeCode(new URLSearchParams(window.location.search).get(URL_PARAM_KEY));
      if (code) return code;

      if (window.__ttDiscountCampaignCode) return sanitizeCode(window.__ttDiscountCampaignCode);

      var meta = document.querySelector('meta[name="tt-discount-campaign"]');
      if (meta && meta.content) return sanitizeCode(meta.content);

      if (window.__st && window.__st.pageurl) {
        var pageurl = window.__st.pageurl;
        if (pageurl.indexOf('http') !== 0) {
          pageurl = 'https://' + pageurl.replace(/^\/+/, '');
        }
        code = sanitizeCode(new URL(pageurl).searchParams.get(URL_PARAM_KEY));
        if (code) return code;
      }
    } catch (e) {}
    return '';
  }

  function stripDiscountFromUrl() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has(URL_PARAM_KEY)) return;
      url.searchParams.delete(URL_PARAM_KEY);
      window.history.replaceState({}, '', url.pathname + (url.search || '') + url.hash);
    } catch (e) {}
  }

  function getStoredCode() {
    if (window.__ttDiscountCampaignCode) {
      return sanitizeCode(window.__ttDiscountCampaignCode);
    }

    var fromSession = '';
    try {
      fromSession = sanitizeCode(sessionStorage.getItem(STORAGE_KEY) || '');
    } catch (e) {}
    if (fromSession) return fromSession;

    var fromCookie = sanitizeCode(readCookie(COOKIE_KEY));
    if (fromCookie) return fromCookie;

    try {
      return sanitizeCode(localStorage.getItem(LOCAL_KEY) || '');
    } catch (e) {}

    return '';
  }

  function storeCode(code) {
    code = sanitizeCode(code);
    if (!code) return;

    window.__ttDiscountCampaignCode = code;

    try {
      sessionStorage.setItem(STORAGE_KEY, code);
    } catch (e) {}

    try {
      localStorage.setItem(LOCAL_KEY, code);
    } catch (e) {}

    writeCookie(COOKIE_KEY, code);
  }

  function captureFromUrl() {
    var code = readFromUrl();
    if (code) {
      storeCode(code);
      stripDiscountFromUrl();
      console.info('[discount-campaign] Captured from URL ?discount_campaign= → session + cookie:', code);
      return code;
    }
    return '';
  }

  function fillCartFormInputs(code) {
    document
      .querySelectorAll('[data-tt-discount-campaign], input[name="attributes[discount_campaign]"]')
      .forEach(function (input) {
        input.value = code || '';
      });
  }

  function ensureFormAttributeInput(form, code) {
    if (!form || !code) return;
    var input = form.querySelector('[name="attributes[discount_campaign]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'attributes[discount_campaign]';
      input.setAttribute('data-tt-discount-campaign', '');
      form.appendChild(input);
    }
    input.value = code;
  }

  function cartRoot() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function fetchCart() {
    return fetch(cartRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      if (!res.ok) throw new Error('cart.js ' + res.status);
      return res.json();
    });
  }

  function cartHasUnwantedAttributes(cart) {
    if (!cart || !cart.attributes) return false;
    return UNWANTED_ATTR_KEYS.some(function (key) {
      return !!cart.attributes[key];
    });
  }

  function prepareCartAttributes(cart, code) {
    var attributes = Object.assign({}, (cart && cart.attributes) || {});
    UNWANTED_ATTR_KEYS.forEach(function (key) {
      if (attributes[key]) attributes[key] = '';
    });
    attributes[ATTR_KEY] = code || '';
    return attributes;
  }

  function cartNeedsAttributeUpdate(cart, code) {
    if (!cart) return false;
    var current = cart.attributes && cart.attributes[ATTR_KEY];
    if (cartHasUnwantedAttributes(cart)) return true;
    if (code) return String(current || '') !== code;
    return !!current;
  }

  function updateCartAttributes(attributes) {
    isInternalCartRequest = true;
    return fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes: attributes }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/update.js ' + res.status);
        return res.json();
      })
      .finally(function () {
        setTimeout(function () {
          isInternalCartRequest = false;
        }, 500);
      });
  }

  function buildSyncState(cart, code) {
    var itemCount = cart && cart.item_count ? cart.item_count : 0;
    var current = cart && cart.attributes ? cart.attributes[ATTR_KEY] : '';
    if (!code) {
      return current ? 'no-code:remove' : 'no-code:clean';
    }
    var prefix = itemCount === 0 ? 'empty' : 'items';
    return prefix + ':' + code + ':' + (String(current || '') === code ? 'ok' : 'set');
  }

  function setCartAttributeForCode(code) {
    code = sanitizeCode(code);
    if (!code) return Promise.resolve(null);

    fillCartFormInputs(code);

    return fetchCart().then(function (cart) {
      if (!cart) return null;

      if (!cartNeedsAttributeUpdate(cart, code)) {
        lastSyncedState = buildSyncState(cart, code);
        return cart;
      }

      return updateCartAttributes(prepareCartAttributes(cart, code)).then(function (updated) {
        lastSyncedState = buildSyncState(updated, code);
        fillCartFormInputs(code);
        console.info('[discount-campaign] Cart attribute set:', code);
        return updated;
      });
    });
  }

  function removeCartAttribute(cart, reason) {
    fillCartFormInputs('');
    if (!cartNeedsAttributeUpdate(cart, '')) return Promise.resolve(cart);

    return updateCartAttributes(prepareCartAttributes(cart, '')).then(function (updated) {
      fillCartFormInputs('');
      console.info('[discount-campaign] ' + reason);
      return updated;
    });
  }

  function queueSync(resetState) {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      syncTimer = null;
      syncCartAttribute(resetState);
    }, 300);
  }

  function syncCartAttribute(resetState) {
    if (isSyncing) {
      queueSync(resetState);
      return Promise.resolve(null);
    }
    if (resetState) lastSyncedState = '';

    isSyncing = true;
    var code = getStoredCode();

    return fetchCart()
      .then(function (cart) {
        if (!cart) return null;

        var syncState = buildSyncState(cart, code);

        if (lastSyncedState === syncState && !cartHasUnwantedAttributes(cart)) return cart;

        if (!code) {
          if (!cartNeedsAttributeUpdate(cart, '')) {
            lastSyncedState = syncState;
            fillCartFormInputs('');
            return cart;
          }
          return removeCartAttribute(cart, 'No session/cookie → removed attribute').then(function (updated) {
            lastSyncedState = buildSyncState(updated, code);
            return updated;
          });
        }

        fillCartFormInputs(code);

        if (!cartNeedsAttributeUpdate(cart, code)) {
          lastSyncedState = syncState;
          return cart;
        }

        return updateCartAttributes(prepareCartAttributes(cart, code)).then(function (updated) {
          lastSyncedState = buildSyncState(updated, code);
          fillCartFormInputs(code);
          console.info('[discount-campaign] Cart attribute set:', code);
          return updated;
        });
      })
      .catch(function (err) {
        console.warn('[discount-campaign-attr]', err);
      })
      .finally(function () {
        isSyncing = false;
      });
  }

  function bindListeners() {
    document.addEventListener('tt:discount-campaign:captured', function (event) {
      var code = event.detail && event.detail.code;
      if (!code) return;
      storeCode(code);
      setCartAttributeForCode(code);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        queueSync(true);
      });
    }

    document.addEventListener('cart:updated', function () {
      if (isInternalCartRequest) return;
      queueSync(true);
    });

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target && event.target.closest ? event.target.closest('form') : null;
        if (!form || !form.getAttribute('action')) return;
        if (!/\/cart\/add/i.test(form.getAttribute('action'))) return;

        var code = getStoredCode();
        if (code) ensureFormAttributeInput(form, code);
        queueSync(true);
      },
      true
    );
  }

  function boot() {
    var urlCode = captureFromUrl();
    fillCartFormInputs(getStoredCode());
    bindListeners();

    if (urlCode) {
      setCartAttributeForCode(urlCode);
    } else {
      queueSync(true);
    }

    var code = getStoredCode();
    if (code) {
      console.info('[discount-campaign] Ready — stored code:', code);
    } else {
      console.info('[discount-campaign] No code yet. Visit any page with ?discount_campaign=YOUR_CODE');
    }
  }

  window.ttDiscountCampaign = {
    get: getStoredCode,
    getSession: function () {
      try {
        return sanitizeCode(sessionStorage.getItem(STORAGE_KEY) || '');
      } catch (e) {
        return '';
      }
    },
    getCookie: function () {
      return sanitizeCode(readCookie(COOKIE_KEY));
    },
    status: function () {
      return fetchCart()
        .then(function (cart) {
          var code = getStoredCode();
          var info = {
            storedCode: code,
            session: window.ttDiscountCampaign.getSession(),
            cookie: window.ttDiscountCampaign.getCookie(),
            cartItemCount: cart ? cart.item_count : 0,
            cartAttribute: cart && cart.attributes ? cart.attributes[ATTR_KEY] || null : null,
            attributeKey: ATTR_KEY,
            pageUrl: window.location.href,
          };
          console.table(info);
          return info;
        })
        .catch(function (err) {
          console.warn('[discount-campaign-attr] status failed', err);
        });
    },
    setCode: function (code) {
      code = sanitizeCode(code);
      if (!code) return Promise.resolve(null);
      storeCode(code);
      console.info('[discount-campaign] Manually set code → session + cookie:', code);
      return syncCartAttribute(true);
    },
    sync: function () {
      return syncCartAttribute(true);
    },
    key: ATTR_KEY,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
